import axios from '../../plugins/axios'

export const fetchBanners = ({ commit }) => {
    const token = JSON.parse(localStorage.getItem('user')).token
    const config = { headers: { Authorization: `Bearer ${token}` } }
    return axios.get('/banners', config)
        .then(response => {
            commit('SET_BANNERS', { banners: response.data })
            return response
        })
        .catch(err => err.response)
}

export const fetchActiveBanners = ({ commit }) => {
    const token = JSON.parse(localStorage.getItem('user')).token
    const config = { headers: { Authorization: `Bearer ${token}` } }
    return axios.get('/banners/active', config)
        .then(response => {
            commit('SET_BANNERS', { banners: response.data })
            return response
        })
        .catch(err => err.response)
}

export const createBanner = (_, payload) => {
    const token = JSON.parse(localStorage.getItem('user')).token
    const config = { headers: { Authorization: `Bearer ${token}` } }
    return axios.post('/banners', payload.data, config)
        .then(response => response)
        .catch(err => err.response)
}

export const updateBanner = (_, payload) => {
    const token = JSON.parse(localStorage.getItem('user')).token
    const config = { headers: { Authorization: `Bearer ${token}` } }
    return axios.put(`/banners/${payload.id}`, payload.data, config)
        .then(response => response)
        .catch(err => err.response)
}

export const deleteBanner = (_, payload) => {
    const token = JSON.parse(localStorage.getItem('user')).token
    const config = { headers: { Authorization: `Bearer ${token}` } }
    return axios.delete(`/banners/${payload.id}`, config)
        .then(response => response)
        .catch(err => err.response)
}

export const fetchDashboardStateCounters = ({ commit }, payload) => {
    const token = JSON.parse(localStorage.getItem('user')).token
    const config = {
        headers: { Authorization: `Bearer ${token}` },
        params: payload ? payload : null
    }
    return axios.get('/dashboard/state-counters', config)
        .then(response => {
            commit('SET_DASHBOARD_STATE_COUNTERS', { dashboardStateCounters: response.data })
            return response
        })
        .catch(err => err.response)
}

export const fetchDeliveryTimeStats = ({ commit }, payload) => {
    const token = JSON.parse(localStorage.getItem('user')).token
    const config = {
        headers: { Authorization: `Bearer ${token}` },
        params: payload ? payload : null
    }
    return axios.get('/dashboard/delivery-time-stats', config)
        .then(response => {
            commit('SET_DELIVERY_TIME_STATS', { deliveryTimeStats: response.data })
            return response
        })
        .catch(err => err.response)
}

export const fetchTopFrequentCustomers = ({ commit }, payload) => {
    const token = JSON.parse(localStorage.getItem('user')).token
    const config = {
        headers: { Authorization: `Bearer ${token}` },
        params: payload ? payload : null
    }
    return axios.get('/dashboard/top-frequent-customers', config)
        .then(response => {
            commit('SET_TOP_FREQUENT_CUSTOMERS', { data: response.data })
            return response
        })
        .catch(err => err.response)
}

export const fetchRepurchaseStats = ({ commit }, payload) => {
    const token = JSON.parse(localStorage.getItem('user')).token
    const config = {
        headers: { Authorization: `Bearer ${token}` },
        params: payload ? payload : null
    }
    return axios.get('/dashboard/repurchase-stats', config)
        .then(response => {
            commit('SET_REPURCHASE_STATS', { repurchaseStats: response.data })
            return response
        })
        .catch(err => err.response)
}

export const fetchDeliveriesByCommune = ({ commit }, payload) => {
    const token = JSON.parse(localStorage.getItem('user')).token
    const config = {
        headers: { Authorization: `Bearer ${token}` },
        params: payload ? payload : null
    }
    return axios.get('/dashboard/deliveries-by-commune', config)
        .then(response => {
            commit('SET_DELIVERIES_BY_COMMUNE', { deliveriesByCommune: response.data })
            return response
        })
        .catch(err => err.response)
}

export const fetchMonthlyDeliveries = ({ commit }, payload) => {
    const token = JSON.parse(localStorage.getItem('user')).token
    const config = {
        headers: { Authorization: `Bearer ${token}` },
        params: payload ? payload : null
    }
    return axios.get('/dashboard/monthly-deliveries', config)
        .then(response => {
            commit('SET_MONTHLY_DELIVERIES', { monthlyDeliveries: response.data })
            return response
        })
        .catch(err => err.response)
}

export const fetchTopStoresByDeliveries = ({ commit }, payload) => {
    const token = JSON.parse(localStorage.getItem('user')).token
    const config = {
        headers: { Authorization: `Bearer ${token}` },
        params: payload ? payload : null
    }
    return axios.get('/dashboard/top-stores', config)
        .then(response => {
            commit('SET_TOP_STORES_BY_DELIVERIES', { data: response.data })
            return response
        })
        .catch(err => err.response)
}
